export const appendConsentResult = (returnUrl: string, result: "granted" | "denied") => {
  const url = new URL(returnUrl);
  url.searchParams.set("personal_data_consent", result);
  return url.toString();
};
